import React, { useState, useEffect } from "react";
import { LockClosedIcon, UserIcon } from "@heroicons/react/24/solid";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import checkLicense from "../util/checkFile";
import axios from "axios";
axios.defaults.baseURL = baseUrl;

const Login = ()=> {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [adminData, setAdminData] = useState({});
  const navigate = useNavigate();

  
  useEffect(()=>{
      const relay_server_token = localStorage.getItem('relay_server_token');
      //console.log(relay_server_token);
      if(relay_server_token)
      {
        navigate("/admin/dashboard");
      }
    },[]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("Login with:", { email, password });
    try {
      const response = await axios.post("admin/relay-login", {        
        email,
        password        
      });

      if (response.data.success) {

        toast.success("Login successfully!");
        setAdminData(response.data.user);
        //console.log(response.data.user);
        localStorage.setItem('relay_server_token', response.data.token);
        localStorage.setItem('relay_server_info', JSON.stringify(response.data.user));
        if(response.data.user)
        {
          navigate("/admin/dashboard");  
        }
              

      } else {
        toast.error(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      //console.error("Registration Error:", error);
      toast.error(error.response.data?.message);
    }
    
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
    <ToastContainer position="top-right" autoClose={3000} />
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <div className="flex justify-center">
          <img src="vsatx.png" alt="logo" width="150" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Login
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Email Field */}
          <div className="relative">
            <UserIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          {/* Password Field */}
          <div className="relative">
            <LockClosedIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-md transition"
          >
            Login
          </button>
        </form>

        <p className="text-sm text-gray-500 mt-6 text-center">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-indigo-600 hover:underline">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
